import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showDialogAction } from 'components/redux-dialog/actions';
import { withReportVideoSelector } from 'common/selectors';
import { REPORT_VIDEO_DIALOG } from 'components/report-video';
import { SimpleDropDownElement } from 'components/simple-dropdown/simple-dropdown-element';

const mapDispatchToProps = (dispatch, props) => ({
  showDialog: () => dispatch(showDialogAction(REPORT_VIDEO_DIALOG, { video: props.video })),
});

const mapStateToProps = (state) => ({
  withReportVideo: withReportVideoSelector(state),
});

let ReportVideo = ({ showDialog, withReportVideo }) => {
  const { t } = useTranslation();

  return !withReportVideo ? null : (
    <SimpleDropDownElement onClick={showDialog} data-e2e="report-video">
      {t('report_video')}
    </SimpleDropDownElement>
  );
};

ReportVideo = connect(mapStateToProps, mapDispatchToProps)(ReportVideo);

export { ReportVideo };
